import React, { useEffect, useState } from 'react';
import axios from 'axios';

const columns = [
  ['ganancia', 'Ganancia'], ['valor_ganado_ticket', 'Ticket ganado'],
  ['entrada_ticket', 'Entrada con ticket'], ['valor_premio_personalizado', 'Premio personalizado'],
  ['ganancias_union_total', 'Total unión'], ['ganancias_union_cuota', 'Cuota'],
  ['ganancias_union_entrada_spinup', 'Entrada SPINUP'], ['ganancias_union_premio_spinup', 'Premio SPINUP'],
  ['ganancias_union_valor_emitido_ticket', 'Ticket emitido'], ['ganancias_union_entrada_ticket', 'Entrada ticket unión'],
  ['ganancias_union_deficit_garantizado', 'Déficit garantizado'],
];
const format = value => typeof value === 'number' && Number.isFinite(value)
  ? value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '—';

export default function PPSTOriginalTotals({ api, dateFrom, dateTo, setDateFrom, setDateTo, refresh }) {
  const [ratio, setRatio] = useState('1:1');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const requestKey = `${dateFrom}|${dateTo}|${ratio}`;
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setResult(null);
    setError('');
    if (dateFrom && dateTo && dateFrom > dateTo) {
      setError('La fecha Desde debe ser anterior o igual a Hasta.');
      return () => { active = false; controller.abort(); };
    }
    axios.get(`${api}/superunion/ppst-originales`, {
      params: { desde: dateFrom, hasta: dateTo, ratio }, signal: controller.signal,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then(({ data }) => { if (active) setResult({ key: requestKey, data }); })
      .catch(() => { if (active) setError('No se pudieron consultar los totales originales. Volvé a abrir esta pestaña para reintentar.'); });
    return () => { active = false; controller.abort(); };
  }, [api, dateFrom, dateTo, ratio, refresh, requestKey]);
  const data = result?.key === requestKey ? result.data : null;
  const ratios = [...new Set(['1:1', ratio, ...(data?.ratios || [])])];
  const cell = 'px-3 py-3 text-right whitespace-nowrap tabular-nums';
  return <section className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
    <div className="bg-slate-800 px-4 py-3 flex flex-wrap items-center justify-between gap-3">
      <h3 className="text-lg font-bold text-white">PPST · Torneos</h3>
      <div className="flex flex-wrap items-center gap-3 text-sm text-white">
        <label>Desde <input aria-label="PPST desde" type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)} className="ml-1 h-9 w-[150px] rounded-lg px-2 text-gray-900" /></label>
        <label>Hasta <input aria-label="PPST hasta" type="date" value={dateTo} onChange={e => setDateTo(e.target.value)} className="ml-1 h-9 w-[150px] rounded-lg px-2 text-gray-900" /></label>
        <label>Ratio <select value={ratio} onChange={e => setRatio(e.target.value)} className="ml-1 h-9 rounded-lg px-2 text-gray-900">
          {ratios.map(r => <option key={r} value={r}>{r}{r === '1:1' ? ' · normalizado' : ''}</option>)}
        </select></label>
      </div>
    </div>
    <div className="px-4 py-3 text-sm text-gray-600 dark:text-gray-300 space-y-2">
      <p>Totales originales del Excel · Ratio {ratio}. Para combinar períodos con distintos ratios, usá 1:1.</p>
      {error ? <p role="alert" className="text-red-600">{error}</p> : !data ? <p role="status">Consultando reportes…</p> : <>
        <p>{data.dias_importados.length} días incluidos. El déficit se cuenta una sola vez por día. «—» indica dato no informado.</p>
        {!!data.dias_sin_original.length && <details className="text-amber-700 dark:text-amber-400">
          <summary>Resultado parcial: {data.dias_sin_original.length} días importados sin originales para este ratio (excluidos).</summary>
          <p className="mt-2 break-words">{data.dias_sin_original.join(', ')}</p>
        </details>}
        {!!data.dias_conflictivos.length && <p role="alert" className="text-red-600">Días excluidos por datos duplicados o inconsistentes: {data.dias_conflictivos.join(', ')}.</p>}
      </>}
    </div>
    {data && <div className="overflow-x-auto"><table className="w-full text-sm">
      <thead className="bg-slate-50 dark:bg-gray-700"><tr>
        <th className="px-3 py-3 text-left">Unión</th><th className={cell}>ID</th>
        {columns.map(([key, title]) => <th key={key} className={cell}>{title}</th>)}
      </tr></thead>
      <tbody className="text-gray-700 dark:text-gray-200">
        {data.uniones.map(row => <tr key={row.union_id} className="border-t border-gray-100 dark:border-gray-700">
          <td className="px-3 py-3 whitespace-nowrap">{row.nombre_union}</td><td className={cell}>{row.union_id}</td>
          {columns.map(([key]) => <td key={key} className={`${cell} ${row[key] < 0 ? 'text-red-600' : ''}`}>{format(row[key])}</td>)}
        </tr>)}
        {!data.uniones.length && <tr><td colSpan={13} className="p-6 text-center">No hay totales originales para este rango y ratio.</td></tr>}
      </tbody>
      {!!data.uniones.length && <tfoot className="bg-slate-100 dark:bg-gray-700 font-semibold"><tr>
        <td colSpan={2} className="px-3 py-3">Total {data.dias_sin_original.length || data.dias_conflictivos.length ? '(parcial)' : ''}</td>
        {columns.map(([key]) => <td key={key} className={cell}>{format(data.totales[key])}</td>)}
      </tr></tfoot>}
    </table></div>}
  </section>;
}
